// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateEstateSnapshotMutationVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  documentIDs: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type GenerateEstateSnapshotMutation = { __typename?: 'Mutation', generateEstateSnapshot: boolean };

export const Operations = {
  Mutation: {
    GenerateEstateSnapshot: 'GenerateEstateSnapshot' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GenerateEstateSnapshotDocument = gql`
    mutation GenerateEstateSnapshot($householdID: ID!, $documentIDs: [ID!]!) {
  generateEstateSnapshot(householdID: $householdID, documentIDs: $documentIDs)
}
    `;
export type GenerateEstateSnapshotMutationFn = Apollo.MutationFunction<GenerateEstateSnapshotMutation, GenerateEstateSnapshotMutationVariables>;

/**
 * __useGenerateEstateSnapshotMutation__
 *
 * To run a mutation, you first call `useGenerateEstateSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEstateSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEstateSnapshotMutation, { data, loading, error }] = useGenerateEstateSnapshotMutation({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      documentIDs: // value for 'documentIDs'
 *   },
 * });
 */
export function useGenerateEstateSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEstateSnapshotMutation, GenerateEstateSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEstateSnapshotMutation, GenerateEstateSnapshotMutationVariables>(GenerateEstateSnapshotDocument, options);
      }
export type GenerateEstateSnapshotMutationHookResult = ReturnType<typeof useGenerateEstateSnapshotMutation>;
export type GenerateEstateSnapshotMutationResult = Apollo.MutationResult<GenerateEstateSnapshotMutation>;
export type GenerateEstateSnapshotMutationOptions = Apollo.BaseMutationOptions<GenerateEstateSnapshotMutation, GenerateEstateSnapshotMutationVariables>;